import { Group } from '@chakra-ui/react'
import type { NodeToolbarProps } from '@xyflow/react'
import { NodeToolbar } from '@xyflow/react'
import type { FC, ReactNode } from 'react'

import useGetIsSelecting from '@app/hooks/useGetIsSelecting'
import useIsAnonymousUser from '@app/hooks/useIsAnonymousUser'
import useIsMobile from '@app/hooks/useIsMobile'

interface Props extends NodeToolbarProps {
  strategyId: string
  children: ReactNode
}

const Toolbar: FC<Props> = ({ strategyId, children, ...rest }) => {
  const isSelecting = useGetIsSelecting()
  const isAnonymousUser = useIsAnonymousUser(strategyId)
  const isMobile = useIsMobile()

  return (
    !isMobile &&
    !isSelecting &&
    !isAnonymousUser && (
      <NodeToolbar offset={50} {...rest}>
        <Group bg="bg" attached colorPalette="gray">
          {children}
        </Group>
      </NodeToolbar>
    )
  )
}

export default Toolbar
